import { useEffect, useState } from 'react'
import { useTranslation } from '../../contexts/LanguageContext'

interface AutoSaveIndicatorProps {
  isDirty: boolean
  lastSaved: Date | null
}

export function AutoSaveIndicator({ isDirty, lastSaved }: AutoSaveIndicatorProps) {
  const { t } = useTranslation()
  const [showSaved, setShowSaved] = useState(false)

  // Show "Saved" briefly after save completes
  useEffect(() => {
    if (lastSaved && !isDirty) {
      setShowSaved(true)
      const timer = setTimeout(() => setShowSaved(false), 2000)
      return () => clearTimeout(timer)
    }
  }, [lastSaved, isDirty])

  if (isDirty) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-amber-600">
        <div className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse" />
        <span>{t.editor.saving}</span>
      </div>
    )
  }

  if (showSaved) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-emerald-600 animate-in fade-in duration-200">
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        <span>{t.editor.saved}</span>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-1.5 text-xs text-slate-400">
      <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
      </svg>
      <span>{t.editor.autoSaved}</span>
    </div>
  )
}
